import LogUtil from '@/core/utils/logUtil';
import CoreEventDispatcher from '@/core/event/coreEventDispatcher';
import CoreEvent from '@/core/event/coreEvent';
import NextStepTransition from '../transition/NextStepTransition';
import type AbstractView from "@/core/view/abstractView";
import type StepFactory from "@/app/views/lifespan/steps/stepFactory";

class StepViewController extends CoreEventDispatcher {

    private _targetNode?:HTMLElement
    private _currentView?:AbstractView;
    private _isTransitionRunning:boolean = false;
    private _viewFactory?:StepFactory;
    private _transition:any;

    constructor() {
        super();
        this._transition = null;
    }

    initialize(targetNode:HTMLElement, viewFactory:StepFactory) {
        this._targetNode = targetNode;
        this._viewFactory = viewFactory;
    }

    loadView(id) {

        if(this._isTransitionRunning) {
            return;
        }

        this._isTransitionRunning = true;

        // create new view
        if (!this._viewFactory) {
            LogUtil.error(this.constructor.name, 'loadview - viewFactory not initialized');
            return;
        }

        let view = this._viewFactory.getViewInstanceById(id); //, params);

        if (!view) {
            LogUtil.error(this.constructor.name, 'loadview - view does not exists');
            return;
        }

        LogUtil.logClass(this,'Load new view:', view.constructor.name);
        this.dispatchEvent(new CoreEvent('LOAD_START', id));


        // render the template before preloading
        view.render();
        if (this._targetNode && view.element) {
            this._targetNode.appendChild(view.element);
        }

        view.postRender();

        view.preload(() => this._onViewPreloadComplete(view));


    }

    _onViewPreloadComplete(viewInstance) {
        LogUtil.logClass(this, 'New view preload complete:', viewInstance.constructor.name);

        this.dispatchEvent(new CoreEvent('LOAD_COMPLETE', viewInstance.id));

        this._transition = new NextStepTransition(this._currentView, viewInstance);
        this._transition.run((view) => this._showViewCallback(view));
    }

    _showViewCallback(view) {
        // remove old view!
        if (this._currentView) {

            this._currentView.destroy();
            if (this._targetNode && this._currentView.element) {
                this._targetNode.removeChild(this._currentView.element);
            }
            this._currentView = undefined;
        }

        if(this._transition) {
            this._transition.destroy();
            this._transition = null;
        }

        this._currentView = view;
        this._isTransitionRunning = false;

        if (this._currentView) {
            LogUtil.logClass(this, 'showViewCallback',this._currentView.id);
            this.dispatchEvent(new CoreEvent('VIEW_CHANGED',this._currentView.id));
        }
    }

    destroy() {

        this.removeAllListeners();

        if(this._currentView) {
            this._currentView.destroy();
            if (this._targetNode && this._currentView.element) {
                this._targetNode.removeChild(this._currentView.element);
            }
            this._currentView = undefined;
        }
    }
}

export default StepViewController;
